import * as es from "@/lang/es";
import * as en from "@/lang/en";

export default {
  es,
  en
};
